/**
 * This file defines the schemas for the playlist agent functions.
 * These schemas follow the OpenAI function calling format.
 */

import { ChatCompletionTool } from 'openai/resources';

export const playlistAgentTools: ChatCompletionTool[] = [
  {
    type: "function",
    function: {
      name: "searchInternet",
      description: "Search the internet for a query.",
      parameters: {
        type: "object",
        properties: {
          query: {
            type: "string",
            description: "The text query to search for with formatiing instructions (e.g. json, markdown)."
          }
        },
        required: ["query"],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "listPlaylists",
      description: "Get a list of the user's playlists from Spotify.",
      parameters: {
        type: "object",
        properties: {},
        required: [],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "getPlaylistDetails",
      description: "Get detailed information about a specific playlist, including its tracks.",
      parameters: {
        type: "object",
        properties: {
          playlistId: {
            type: "string",
            description: "The ID of the playlist to get details for."
          }
        },
        required: ["playlistId"],
        additionalProperties: false
      },
      strict: true
    }
  },
  {
    type: "function",
    function: {
      name: "generatePlaylist",
      description: "Generate a playlist using AI based on a description.",
      parameters: {
        type: "object",
        properties: {
          description: {
            type: "string",
            description: "A description of the type of playlist to generate. Include the track names you would like to try and include (depending on availability)"
          },
          options: {
            type: "object",
            properties: {
              mood: {
                type: "string",
                description: "The mood of the playlist (e.g., happy, sad, energetic)."
              },
              era: {
                type: "string",
                description: "The era of music to include (e.g., 80s, 90s, 2000s)."
              },
              trackCount: {
                type: "integer",
                description: "The number of tracks to include in the playlist."
              }
            },
            required: ["mood", "era", "trackCount"],
            additionalProperties: false
          }
        },
        required: ["description", "options"],
        additionalProperties: false
      },
      strict: true
    }
  }
];
